import { createSlice } from "@reduxjs/toolkit";

const initialStorefrontsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  lastError: null,
  error: null,
  warehouseEntities: null,
  description: null,
  completed: false,
  storefrontOneForStockTransfer: null,
  storefrontTwoForStockTransfer: null,
  storefrontsForExport: null,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const storefrontsSlice = createSlice({
  name: "storefronts",
  initialState: initialStorefrontsState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error?.constructor?.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.message.error = null;
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    storefrontCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { entity, message } = action.payload;
      state.entities.push(entity);
      state.message.success = message;
      state.completed = true;
    },

    // updatestorefront
    storefrontUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      const { entity, message } = action.payload;
      state.entities = state.entities.map((item) => {
        if (item.id === entity.id) {
          item = entity;
        }
        return item;
      });
      state.message.success = message;
      state.completed = true;
    },
    // deletestorefront
    storefrontDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      const { message, id } = action.payload;
      state.entities = state.entities.filter((el) => el.id !== Number(id));
      state.message.success = message;
    },
    storefrontDeletedToNull: (state) => {
      // state.message.error = null;
      state.message.success = null;
    },
    //storefront description
    changeCompleteStatus: (state, action) => {
      state.message.success = null;
      state.completed = action.payload.status;
    },

    // deletestorefronts
    storefrontsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => !action.payload.ids.includes(el.id));
    },
    // storefrontsUpdateState
    storefrontsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    storefrontFetched: (state, action) => {
      const { totalCount, entities, storefrontsForExport } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.entities = entities;
      state.storefrontsForExport = storefrontsForExport;
    },
    storefrontsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      if (action.payload.optionalIdForExtraStorefrontObjects == 1) {
        state.storefrontOneForStockTransfer = entities;
      } else if (action.payload.optionalIdForExtraStorefrontObjects == 2) {
        state.storefrontTwoForStockTransfer = entities;
      }

      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.entities = entities;
    },
    warehousesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.warehouseEntities = entities;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
